import type { ReactNode } from 'react';
import WordmarkSprite from './WordmarkSprite';
import Announce from './Announce';
import Nav from './Nav';
import Footer from './Footer';
import { useReveal } from '../hooks/useReveal';
import { useCitePopovers } from '../hooks/useCitePopovers';

/** Shared page chrome: announcement bar, sticky nav, the page, footer. Wraps every page via
 *  wrapPageElement. Also owns the document-wide behaviours from site.js that every page needs
 *  (scroll reveal, citation popovers); Gatsby handles scroll restoration and hash targets. */
export default function Layout({ pathname, children }: { pathname: string; children: ReactNode }) {
  // These run after the page has mounted (child effects fire first).
  useReveal(pathname);
  useCitePopovers(pathname);

  return (
    <>
      <a className="skip" href="#main">Skip to content</a>
      <WordmarkSprite />
      <Announce pathname={pathname} />
      <Nav pathname={pathname} />
      <main id="main">{children}</main>
      <Footer />
    </>
  );
}
